import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

import "./MainMenu.html";
import { MainMenuComponentController } from "./MainMenuComponentController";

export class MainMenuComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            isDisabled: "<?",
        };
        this.controller = MainMenuComponentController;
        this.templateUrl = "/App/Components/Core/MainMenu/MainMenu.html";
        this.transclude = true;
    }
}

module("mmManagePortal").component("mmMainMenu", new MainMenuComponent());
